import { ObservableInput, combineLatest } from 'rxjs';
import { map, distinctUntilChanged } from 'rxjs/operators';

export const allTrue = (...observables: Array<ObservableInput<boolean>>) =>
  combineLatest(observables).pipe(
    map((values) => values.every((v) => v === true)),
    distinctUntilChanged()
  );
